import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
export function ComparisonTable() {
  const badPoints = ['Prueba y error constante con materiales caros', 'Soldaduras frágiles que se rompen al moverlo', 'Cables a la vista que arruinan la estética', 'No sabe cómo cobrar y termina perdiendo plata', 'Carteles que parpadean o se queman rápido'];
  const goodPoints = ['Sigue un método paso a paso profesional', 'Soldadura impecable y conexiones seguras', 'Cableado invisible y terminaciones premium', 'Sabe calcular costos y vende con alto margen', 'Carteles duraderos con garantía de calidad'];
  return <section className="py-20 relative z-10 bg-gradient-to-b from-[#0a0a2e] via-[#0f0b35] to-[#1a0b2e] pt-[8px] pb-[30px]" data-id="element-100">
      <div className="max-w-7xl mx-auto px-4 mb-16 text-center" data-id="element-101">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#00f0ff]/10 border border-[#00f0ff]/30 text-[#00f0ff] text-sm font-black mb-6 tracking-widest uppercase" data-id="element-102">
          🚀 LA TRANSFORMACIÓN
        </motion.div>
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-6xl font-black text-white mb-6 tracking-tight leading-tight uppercase" data-id="element-103">
          TU CAMINO AL <span className="text-[#ec4899]" data-id="element-104">ÉXITO</span>
        </motion.h2>
        <p className="text-xl text-gray-400 max-w-2xl mx-auto font-medium" data-id="element-105"></p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-0 w-full" data-id="element-106">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="bg-[#1a0b2e]/40 overflow-hidden flex flex-col relative group" data-id="element-107">
          <div className="p-8 md:p-12 bg-black/20 border-b border-white/5 pt-[0px] pb-[30px]" data-id="element-108">
            <p className="text-white text-2xl md:text-3xl font-black uppercase tracking-tighter leading-tight max-w-md" data-id="element-109">
              "Sin guía, solo hay frustración, errores costosos y materiales
              desperdiciados."
            </p>
          </div>
          <img src="https://cdn.magicpatterns.com/uploads/7EHYfxaDiXJLn64BW3P8tw/ChatGPT_Image_23_jun_2026,_13_43_34.webp" alt="Problemas Neon Flex" className="w-full h-auto block" data-id="element-110" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="bg-[#1a0b2e]/60 overflow-hidden flex flex-col" data-id="element-111">
          <div className="p-8 md:p-12 bg-[#00f0ff]/5 border-b border-[#00f0ff]/20" data-id="element-112">
            <p className="text-[#00f0ff] text-2xl md:text-3xl font-black uppercase tracking-tighter leading-tight max-w-md" data-id="element-113">
              "Con nuestra maestría: resultados profesionales y un negocio
              rentable."
            </p>
          </div>
          <img src="https://cdn.magicpatterns.com/uploads/cvNvjCDyTrhi3hrNQeLXbP/ChatGPT_Image_23_jun_2026,_13_43_34_(1).webp" alt="Soluciones Neon Flex" className="w-full h-auto block" data-id="element-114" />
        </motion.div>
      </div>
    </section>;
}